// ========================================================= Start APP ROUTES ================================================
import type { AuthContextQueryParam } from "~/types/auth";

// ------------------------------ App protected routes ------------------------------
const protectedRoutes = [
  {
    label: "Profile",
    icon: "heroicons:user-circle",
    to: "/users/profile",
  },
  {
    label: "Settings",
    icon: "heroicons:cog-6-tooth",
    to: "/users/settings",
  },
];

const appAuthRoutes = {
  login: { title: "Login", path: "/auth/login" },
  continue: {
    title: "Continue",
    path: (context: AuthContextQueryParam) =>
      `/auth/continue?context=${context}`,
  },
  register: {
    initRegistration: {
      title: "initRegistration",
      path: "/auth/register?context=signUp",
    },
    verifyRegistration: {
      title: "Verify Register",
      path: "/auth/register/verify-account",
    },
    processAccountVerification: {
      title: "Process verify Register",
      path: "/auth/register/process-verify-account",
    },
  },
  logout: { title: "Logout", path: "/auth/logout" },
};
const appHomeRoute = { title: "Home", path: "/" };

// ------------------------------ App routes utils ------------------------------
const isGuestRoute = (path: string) => {
  const routes = [
    appAuthRoutes.login,
    ...Object.values(appAuthRoutes.register),
    appAuthRoutes.logout,
  ];
  const routesGuest = routes.map((r) => r.path);
  return routesGuest.includes(path);
};
const isProtectedRoute = (path: string) => {
  const routes = [...protectedRoutes.map((r) => r.to)];
  console.log(routes);

  return routes.includes(path);
};

const goTo = (path: string, replace = false) => {
  let options = {};

  if (replace) {
    options = { ...options, replace: true };
  }
  return navigateTo(path, options);
};

const reloadRoute = (path: string) => {
  if (import.meta.client) {
    window.location.href = path;
  }
};

// ========================================================= END APP ROUTES ================================================

// ========================================================= Start Api routes ================================================
const apiRoutes = {
  // --------------------------------------- auth
  login: { title: "Login", path: "/login" },
  refreshToken: { title: "RefreshToken", path: "/refresh/token" },
  register: {
    initRegistration: "/sign-up",
    validateRegistration: "/verify-sign-up",
    resendEmailVerificationCode: (id: string) =>
      `/resend-email-verification-code/${id}`,
  },
  logout: { title: "Logout", path: "/refresh/logout" },
  // --------------------------------------- users
  users: {
    me: { title: "Me", path: "/me" },
  },
};
// ========================================================= End Api routes ================================================
export {
  appAuthRoutes,
  isGuestRoute,
  appHomeRoute,
  apiRoutes,
  goTo,
  reloadRoute,
  isProtectedRoute,
};
